<app-packaging-navigation [itemId]="packagingUnit.id" [callerLevelId]="packagingPartType"
  [callerTypeId]="packagingUnit.packagingTypeId" [currentDirectoryId]="packagingUnit.directoryId" [brandName]="packagingUnit.brandName"
  [productName]="packagingUnit.productName" [articleNumber]="packagingUnit.articleNumber"
  [versionId]="packagingUnit.version" [isCurrentVersion]="packagingUnit.isCurrentVersion"
  [hasRecyclabilityResult]="packagingUnit.hasRecyclabilityResult" [hasLifeCycleResult]="packagingUnit.hasLifeCycleResult"
  [creationTimestamp]="packagingUnit.creationTimestamp">

  <div id="versions-container" *ngIf="!isUserValidator">
    <mat-form-field class="form-field-versions">
      <mat-label>{{ 'home.packagingUnitHome.historyVersion' | transloco }}</mat-label>
      <mat-select [(value)]="selectedExpenseResults">
        <mat-option *ngFor="let analysisVersion of expenseResults" [value]="analysisVersion">
          {{ 'analysis.calculatedOn' | transloco }}
          {{ getDateTimeString(analysisVersion[0].evaluationReferenceTimestamp) }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <span id="analysis-id">
      <ng-container *ngIf="selectedExpenseResults[0].licenseFee">
        {{ 'analysis.licenseFeeId' | transloco }}: <b>{{selectedExpenseResults[0].licenseFee.id}}</b>
        <button id="copy-button" mat-icon-button color="primary" [cdkCopyToClipboard]="selectedExpenseResults[0].licenseFee.id">
          <mat-icon>content_copy</mat-icon>
        </button>
      </ng-container>

      <ng-container *ngIf="selectedExpenseResults[0].ecomodulation">
        {{ 'analysis.ecomodulationId' | transloco }}: <b>{{selectedExpenseResults[0].ecomodulation.id}}</b>
        <button id="copy-button" mat-icon-button color="primary" [cdkCopyToClipboard]="selectedExpenseResults[0].ecomodulation.id">
          <mat-icon>content_copy</mat-icon>
        </button>
      </ng-container>

      <ng-container *ngIf="selectedExpenseResults[0].plasticTax">
        {{ 'analysis.plasticTaxId' | transloco }}: <b>{{selectedExpenseResults[0].plasticTax.id}}</b>
        <button id="copy-button" mat-icon-button color="primary" [cdkCopyToClipboard]="selectedExpenseResults[0].plasticTax.id">
          <mat-icon>content_copy</mat-icon>
        </button>
      </ng-container>

    </span>
  </div>

  <mat-tab-group dynamicHeight>
    <mat-tab [label]="'analysis.expenseCalculation.licenseFee.title' | transloco">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFee' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.ecomodulation' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFeeVsEcomodulation' | transloco"></p>
        <app-expense-calculation-html-template [expenseResults]="selectedExpenseResults" [displayType]="DisplayType.licenseFee" [packagingPart]="packagingUnit"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.licenseFee.title' | transloco"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>

    <mat-tab [label]="'analysis.expenseCalculation.plasticTax.title' | transloco">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.plasticTax'| transloco"></p>
        <app-expense-calculation-html-template [expenseResults]="selectedExpenseResults" [displayType]="DisplayType.plasticTax" [packagingPart]="packagingUnit"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.plasticTax.title' | transloco"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>

    <mat-tab [label]="'analysis.expenseCalculation.total.title' | transloco">
      <div class="tab-container">
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFee' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.ecomodulation' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.licenseFeeVsEcomodulation' | transloco"></p>
        <p [innerHTML]="'analysis.expenseCalculation.descriptions.plasticTax'| transloco"></p>
        <app-expense-calculation-html-template [expenseResults]="selectedExpenseResults" [displayType]="DisplayType.total" [packagingPart]="packagingUnit"
          [packagingPartType]="packagingPartType" [title]="'analysis.expenseCalculation.total.title' | transloco"
          [licenseFeeCountries]="licenseFeeCountries" [ecomodulationCountries]="ecomodulationCountries" [plasticTaxCountries]="plasticTaxCountries">
        </app-expense-calculation-html-template>
      </div>
    </mat-tab>
  </mat-tab-group>



</app-packaging-navigation>
